module.exports = __webpack_public_path__ + "assets/img/bg.5b05bf53.png";